/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_stopwatch_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — open the stopwatch page in a second browser tab and each one runs independently. This is handy for timing two things in parallel, like two runners on different legs of a relay.`)
};

const es_timer_stopwatch_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí — abre la página del cronómetro en una segunda pestaña del navegador y cada uno funciona de forma independiente. Es útil para cronometrar dos cosas en paralelo, como dos corredores en distintos tramos de una posta.`)
};

const de_timer_stopwatch_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — öffne die Stoppuhr-Seite in einem zweiten Browser-Tab, dann läuft jede unabhängig. Praktisch, um zwei Dinge parallel zu stoppen, etwa zwei Läufer auf unterschiedlichen Staffelabschnitten.`)
};

const nl_timer_stopwatch_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — open de stopwatchpagina in een tweede browsertabblad en elke stopwatch draait onafhankelijk. Handig om twee dingen gelijktijdig te timen, zoals twee lopers op verschillende etappes van een estafette.`)
};

const fr_timer_stopwatch_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui — ouvrez la page du chronomètre dans un second onglet du navigateur et chacun fonctionne indépendamment. C’est pratique pour chronométrer deux choses en parallèle, comme deux coureurs sur différents relais.`)
};

const it_timer_stopwatch_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì — apri la pagina del cronometro in una seconda scheda del browser e ognuno funzionerà in modo indipendente. È utile per cronometrare due cose in parallelo, come due corridori su tratti diversi di una staffetta.`)
};

const pt_br2_timer_stopwatch_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — abra a página do cronômetro em uma segunda aba do navegador e cada um roda de forma independente. Isso é útil para cronometrar duas coisas em paralelo, como dois corredores em trechos diferentes de um revezamento.`)
};

const pt_timer_stopwatch_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — abra a página do cronómetro num segundo separador do navegador e cada um funciona de forma independente. Isto é útil para cronometrar duas coisas em paralelo, como dois corredores em diferentes etapas de uma estafeta.`)
};

const ja_timer_stopwatch_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。別のブラウザタブでストップウォッチのページを開けば、それぞれ独立して動作します。リレーの異なる区間を走る2人のランナーなど、2つのものを並行して計測したいときに便利です。`)
};

const zh_timer_stopwatch_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以 — 在第二个浏览器标签页中打开秒表页面，每个秒表都会独立运行。这对同时为两件事计时很方便，比如接力赛中不同跑者的用时。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_stopwatch_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_stopwatch_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_stopwatch_faq4_a", locale)
	if (locale === "en") return en_timer_stopwatch_faq4_a(inputs)
	if (locale === "es") return es_timer_stopwatch_faq4_a(inputs)
	if (locale === "de") return de_timer_stopwatch_faq4_a(inputs)
	if (locale === "nl") return nl_timer_stopwatch_faq4_a(inputs)
	if (locale === "fr") return fr_timer_stopwatch_faq4_a(inputs)
	if (locale === "it") return it_timer_stopwatch_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_stopwatch_faq4_a(inputs)
	if (locale === "pt") return pt_timer_stopwatch_faq4_a(inputs)
	if (locale === "ja") return ja_timer_stopwatch_faq4_a(inputs)
	return zh_timer_stopwatch_faq4_a(inputs)
};